import { css, keyframes } from '@emotion/react'
import { Theme } from '@mui/material'

const fadeIn = keyframes`
  from {
    opacity: 0.5;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const thumbnailListItem = (theme: Theme) => css`
  background-color: ${theme.palette.white.main};
  border-radius: 8px 8px 60px 0px;
  overflow: hidden;
  width: 264px;
  height: 348px;
  filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.15));
  transition: box-shadow 0.2s ease-in-out;
  animation: ${fadeIn} 0.2s ease-in-out;

  display: flex;
  flex-direction: column;

  .thumbnail {
    height: 176px;
    min-height: 176px;
    width: 100%;
    position: relative;

    .cover {
      width: 100%;
      height: 100%;
      object-fit: cover;
      background-color: ${theme.palette.white.dark};
    }

    .formatIcon {
      position: absolute;
      bottom: -20px;
      left: 24px;
      width: 52px;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: ${theme.palette.uintel.main};
      border-radius: 50%;

      img {
        width: 28px;
        height: 28px;
      }
    }
  }

  .label {
    padding: 36px;

    .format {
      font-size: 12px;
      line-height: 1.2;
      font-weight: 800;
      color: ${theme.palette.uintel.main};
    }

    .title {
      font-size: 18px;
      line-height: 1.2;
      color: ${theme.palette.black.main};
      margin-top: 4px;
      height: 44px;
      max-height: 44px;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      white-space: normal;
    }

    .button {
      position: absolute;
      bottom: 32px;
      right: 36px;
      font-size: 14px;
      color: ${theme.palette.blue.light};
      font-weight: 500;
      line-height: 1.55;
    }
  }

  &:hover {
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
    cursor: pointer;
  }
`
